<template>
  <div class="flex items-center">
    <img class="w-10 h-10 rounded-full bg-gray-base" :src="avatarUrl" alt="" />
    <div class="ml-3">
      <p class="font-semibold text-xs tracking-wider text-gray-1 uppercase">
        {{ creditorName }}
      </p>
      <p class="text-xs text-gray-2 opacity-70">{{ creditorTaxId }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    creditorName: String,
    creditorTaxId: String,
    avatarUrl: {
      type: String,
      default: "assets/img/icons/user.svg",
    },
  },
})
export default class CreditorInfo extends Vue {}
</script>
